  export const Configuration = {
    environmentName: "production",
    logLevel: "debug",
    version: {
      long: "26.10.2+261019173129.ge11b11d5d",
      short: "26.10.2"
    }
  };
